import React , {useEffect, useState } from "react";
import { GetProfileImages } from "../DocumentDetails/slice";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Chip from "@mui/material/Chip";
import Avatar from "@mui/material/Avatar";
import { Divider, Typography } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import {
  collection as firebaseCollection,
  orderBy,
  query,
  onSnapshot,
  limit,
  where,
} from "firebase/firestore";
import { db } from "../../firebase";
import { DEFAULT_AVATAR_URL } from "../../common/enum";

const NotificationListSignalIR = (allNotificacoesNotRead) => {
  const [entities, setEntites] = React.useState([]);
  const {
    auth: { profile },
  } = useSelector((state) => state);


const [profileImages, setProfileImages] = useState(new Map());
const dispatch = useDispatch();

useEffect(() => {
  const fetchImages = async () => {
    const newMap = new Map();

    const notificacoes = allNotificacoesNotRead?.allNotificacoesNotRead || [];

    for (const item of notificacoes) {
      const id = item?.entityDetails?.profilePicture;
      if (id && id !== "string") {
        const result = await dispatch(GetProfileImages(id));
        const imageUrl = result?.payload?.isActive;
        if (imageUrl != null) {
            newMap.set(item?.entityDetails?.entityId, imageUrl);
        }else{
            newMap.set(item?.entityDetails?.entityId, DEFAULT_AVATAR_URL);
        }
        
      }
    }

    setProfileImages(newMap);
  };

  fetchImages();
}, [dispatch, allNotificacoesNotRead?.allNotificacoesNotRead]);


  return (
    <Box dense sx={{ width: "100%" }}>
      {Object.values(allNotificacoesNotRead).length > 0 &&
        Object.values(allNotificacoesNotRead)[0].map((value) => {
          const labelId = `checkbox-list-secondary-label-${value.donorUserId}`;
          return (
            <React.Fragment key={value.entityId}>
              <Box sx={{ p: 0, my: 1 , display:"flex"}}>
                <ListItemAvatar>
                  <Avatar
                    alt={value.entityDetails.entityName}
                    src={
                      value.entityDetails ? value.entityDetails.profilePicture ===
                        "string" ||
                        value.entityDetails.profilePicture === null
                        ? DEFAULT_AVATAR_URL
                        : profileImages.get(value.entityDetails.entityId) 
                        : value.entityDetails.profilePicture ===
                        "string" ||
                        value.entityDetails.profilePicture === null
                        ? DEFAULT_AVATAR_URL
                        : profileImages.get(value.entityDetails.entityId) 
                    }
                    sx={{
                      backgroundColor: "green",
                      "& img": {
                        height:
                        value.entityDetails ? value.entityDetails.profilePicture ===
                            "string" ||
                            value.entityDetails.profilePicture === null
                            ? "100%"
                            : "100%"
                            :value.entityDetails.profilePicture ===
                            "string" ||
                            value.entityDetails.profilePicture === null
                            ? "100%"
                            : "100%",
                        width:
                        value.entityDetails?
                        value.entityDetails.profilePicture ===
                            "string" ||
                            value.entityDetails.profilePicture === null
                            ? "100%"
                            : "100%"
                            :
                            value.entityDetails.profilePicture ===
                            "string" ||
                            value.entityDetails.profilePicture === null
                            ? "100%"
                            : "100%"
                      },
                    }}
                  />
                </ListItemAvatar>
                <ListItemText
                  id={labelId}
                  primary={
                    <Typography variant="body2" fontWeight={600} className="LabelNomeResize">
                      {value.entitySenderDetails.entidadeEnvio}
                    </Typography>
                  }
                />
                <Chip
                  // label={`${new Date(
                  //   value.collection.collection.createdDate
                  // ).getFullYear()}${value.collection.collection.id}`}
                  label={value.entitySenderDetails.codDoacao}
                  sx={{
                    backgroundColor: "#E4F2E8",
                    color: "#1B727E",
                    mx: 1,
                    "& .MuiChip-label": {
                      fontWeight: 600,
                      fontFamily: "Poppins",
                    },
                  }}
                />
                <ListItemText
                  id={labelId}
                  
                  secondary={`${new Date(value.entitySenderDetails.updatedDate).toLocaleTimeString("pt", {
                    hour: "numeric",
                    minute: "numeric",
                  })}m`}
                />
              </Box>
              <Divider sx={{ borderColor: "rgba(145, 158, 171, 0.69)" }} />
            </React.Fragment>
          );
        })}
    </Box>
  );
};

export default NotificationListSignalIR;
